import { createContext, useContext } from 'react';
import type { SessionData } from '@/types';

/**
 * 会话管理 Context
 * 管理会话列表和会话操作
 */
export interface SessionContextType {
  /** 会话列表 */
  sessionList: SessionData[];
  /** 会话分页信息 */
  sessionPagination: {
    total: number;
    pageNum: number;
    pageSize: number;
  };
  /** 删除会话 */
  deleteSession: (sessionId: string) => void;
  /** 更新会话标题 */
  updateSession: (sessionId: string, title: string) => void;
  /** 设置当前会话详情 */
  setCurrentSession: (sessionId: string) => void;
}

export const SessionContext = createContext<SessionContextType | null>(null);

/**
 * 使用会话管理 Hook
 * @returns SessionContextType
 * @throws Error 如果在 XAdkProvider 外部使用
 */
export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within XAdkProvider');
  }
  return context;
};
